import { Modal } from "antd";
import { default as React, Fragment, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { fetchTestApi } from "../../../api/fetchTest";
import Card from "../../../components/card/card";
import TestInstruction from "../../../components/testInstruction/testInstruction";
import { getFullScreen } from "../../../helper/fullscreen";
import { arrayValidation } from "../../../helper/validation";
import { HelperContext } from "../../../store/helperStore";
import { LaunchTestContext } from "../../../store/launchTestStore";
import { NoAnyTestAvail } from "./noAnyTestAvail";
function GetTestCard({ testData, type, instVisible, handleInstVisible }) {
  const { helperC, dispatchHelper } = HelperContext();
  const { launchTestC, dispatchLaunchTest } = LaunchTestContext();
  const history = useHistory();
  const { launchTestData } = launchTestC;

  useEffect(() => {
    let timeout;
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const handleCardClick = (testData, type) => {
    handleInstVisible(true);
    // setInstVisible(true);
    const varGradeId = JSON.parse(localStorage.getItem("gradeId"));
    fetchTestApi(
      testData.test_id,
      varGradeId, // variable grade id
      dispatchLaunchTest,
      dispatchHelper //for storing first question id
    );
  };

  const handleLaunchTest = (type) => {
    if (type === "DEMO") {
      dispatchHelper({
        type: "TEST_TYPE",
        payload: "DEMO",
      });
    } else {
      dispatchHelper({
        type: "TEST_TYPE",
        payload: "",
      });
    }
    history.push({
      pathname: `/amaze_test`,
      state: { routeFrom: "startTest" },
    });
    getFullScreen();
  };

  const handleInstCancel = () => {
    // setInstVisible(false);
    handleInstVisible(false);
    dispatchHelper({
      type: "TEST_TYPE",
      payload: "",
    });
  };

  return (
    <>
      {arrayValidation(testData) ? (
        <div className="categories-tests">
          {testData.map((filData, index) => {
            return (
              <Fragment key={index}>
                {
                  <Card
                    testData={filData}
                    onClick={() => {
                      handleCardClick(filData, type);
                      dispatchHelper({
                        type: "TEST_SECTION",
                        payload: filData.group_name,
                      });
                    }}
                  />
                }
              </Fragment>
            );
          })}
        </div>
      ) : (
        <div className="">
          <NoAnyTestAvail />
        </div>
      )}
      <InstructionModal
        instVisible={instVisible}
        handleInstCancel={handleInstCancel}
        handleLaunchTest={handleLaunchTest}
        launchTestData={launchTestData}
      />
    </>
  );
}

export default React.memo(GetTestCard);

function InstructionModal({
  instVisible,
  handleInstCancel,
  handleLaunchTest,
  launchTestData,
}) {
  return (
    <Modal
      // style={{ top: 12 }}
      style={{ top: 12, maxWidth: "1082px" }}
      width="98%"
      visible={instVisible}
      className="sml-modal dash-inst"
      onCancel={handleInstCancel}
      footer={null}
    >
      <TestInstruction
        launchTestData={launchTestData}
        handleBtn1={() => handleLaunchTest("DEMO")}
        handleBtn2={() => handleLaunchTest("")}
        btnName1="Take Demo"
        btnName2="Start Test"
      ></TestInstruction>
    </Modal>
  );
}
